import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.png";
import Home2 from "./Home2";
import { Link } from "react-router-dom";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="hero-container">
          {/* Split-Screen Hero Section */}
          <div className="hero-grid">
            {/* Left Side - Content */}
            <div className="hero-content">
              <h1 className="hero-title">
                Transforming Ideas Into <span className="glow-text" data-text="Digital Reality">Digital Reality</span>
              </h1>
              
              <p className="hero-description">
                Full-stack developer passionate about creating elegant, high-performance web solutions that blend technology, creativity, and intelligence. Building the future, one line of code at a time.
              </p>

              <div className="hero-buttons">
                <Link to="/project" className="btn-circle-project">View Projects</Link>
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="hero-image-section">
              <div className="hero-image-wrapper">
                <img
                  src={homeLogo}
                  alt="Developer Portrait"
                  className="hero-image"
                />
                <div className="hero-image-accent">
                  <div className="accent-line accent-line-top"></div>
                  <div className="accent-line accent-line-bottom"></div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Container>

      <Home2 />

      <Container>
        <Row style={{ paddingTop: "50px", paddingBottom: "80px" }}>
          <Col md={12} className="home-about-social">
            <h1>Find Me On</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/dikshajha25"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/diksha_jha25"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="www.linkedin.com/in/diksha-jha-8368a0295"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/dikshajh.a"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;
